import React, {Component} from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ListItem from '../../../content/components/social/list-item';
import { fetchSocial } from 'ActionsSocial';
import TablebodyItem from './tablebody-item';
import HeaderFooter from './headerfooterList';
import FooterList from './footerList';

class TableContent extends Component {

  // renderList(){
  //   // let values={id:1}
  //   return   <TablebodyItem values={values}/>;
  // }
  renderList(){
    var items=_.map( this.props.websitePages.resource, values => <TablebodyItem key={values.id} values={values}/>);
    return items;
  }
  headerfooterrenderList(){
    var response=_.map( this.props.headerFooter.resource, (values,index ) => <HeaderFooter key={values.id} values={values}/>);
    return response;
  }
  footerrenderList(){
    var data=_.map( this.props.headerFooter.resource, (values,index ) => <FooterList key={values.id} values={values}/>);
    return data;
  }

  render(){
    return(
    <div className="social-content">
      <table className="table">
        <thead>
          <tr>
              <th>Page Title</th>
              <th>URL</th>
              <th>Unpublish/Publish</th>
              <th>Action</th>
              
          </tr>
        </thead>
        <tbody className="tbody-background">
           {this.renderList()}
           {this.headerfooterrenderList()}
           {this.footerrenderList()}
        </tbody>

      </table>
    </div>
    );
  }
}


function mapStateToProps(state){
  return {
    // socials: state.socials,
    session: state.session,
    websitePages:state.websitePages,
    headerFooter:state.headerFooter,
    
  };
}

export default connect(mapStateToProps)(TableContent);